import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { isLoggedIn, UnauthorizedError } from './lib/api';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { CostsPage } from './pages/CostsPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { OrganizationAccountPage } from './pages/OrganizationAccountPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { PricingPage } from './pages/PricingPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { PoliciesPage } from './pages/PoliciesPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // cost data changes slowly; avoid hammering Cost Explorer
      retry: (failureCount, error) => !(error instanceof UnauthorizedError) && failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
});

function RequireAuth() {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/organizations" element={<OrganizationsPage />} />
            <Route path="/organizations/:orgId" element={<OrganizationAccountPage />} />
            <Route path="/costs" element={<CostsPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/policies" element={<PoliciesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
